module.exports = __webpack_public_path__ + "static/media/44.04b83df4.gif";